import React from 'react';
import PropTypes from 'prop-types';
import ApiDcosxmlpath from '.././../../../data/cms/enums';
import ApiName from './apinames';

type Props = {
    ApiHelpName: any,
};
function GetXmlpath(props: Props) {
    const [ApiHelpName] = React.useState(props);
    var XMLPath = '';
    switch (true) {
    case ApiHelpName === ApiName.GetToken.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetToken;
        break;
    case ApiHelpName === ApiName.GetTokenOAuth.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetTokenOAuth;
        break;

    case ApiHelpName === ApiName.TaxSoftware.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiTaxSotware;
        break;
    case ApiHelpName === ApiName.BinderTypes.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiBinderTypes;
        break;
    case ApiHelpName === ApiName.ServiceTypes.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiServiceTypes;
        break;
    case ApiHelpName === ApiName.BinderTemplates.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiBinderTemplates;
        break;
    case ApiHelpName === ApiName.OfficeLocations.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiOfficeLocations;
        break;
    case ApiHelpName === ApiName.BinderStatusList.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiBinderStatusList;
        break;
    case ApiHelpName === ApiName.CreateBinder.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiCreateBinder;
        break;
    case ApiHelpName === ApiName.UploadBinder.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiUploadBinder;
        break;
    case ApiHelpName === ApiName.BinderSubmit.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiBinderSubmit;
        break;
    case ApiHelpName === ApiName.UploadProject:
        XMLPath = ApiDcosxmlpath.ApiUploadProject;
        break;
    case ApiHelpName === ApiName.GetStatus.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetStatus;
        break;
    case ApiHelpName === ApiName.ChangeBinderStatus.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiChangeBinder;
        break;
    case ApiHelpName === ApiName.GetBinderDetails.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetBinderDetails;
        break;
    case ApiHelpName === ApiName.GetDocuments.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetDocuments;
        break;
    case ApiHelpName === ApiName.DownloadDocuments.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiDownloadDocument;
        break;
    case ApiHelpName === ApiName.UnClearNotes.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiUnclearNotes;
        break;
    case ApiHelpName === ApiName.UnReviewedTrs.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiUnReviewedTRS;
        break;
    case ApiHelpName === ApiName.GetUnreviewedStickyNotes.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiStickyNotes;
        break;
    case ApiHelpName === ApiName.UnReviewedWorkPaper1.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiWorkpapersbyL1;
        break;
    case ApiHelpName === ApiName.UnReviewedWorkPaper2.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiWorkpapersbyL2;
        break;
    case ApiHelpName === ApiName.UnReviewedWorkPaper3.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiWorkpapersbyL3;
        break;
    case ApiHelpName === ApiName.UnReviewedWorkPaper4.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiWorkpapersbyL4;
        break;
    case ApiHelpName === ApiName.RequestedDocsPendingReview.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiPendingReview;
        break;
    case ApiHelpName === ApiName.RequestedDocsPendingSignature.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiPendingSignature;
        break;
    case ApiHelpName === ApiName.RequestedDocsPendingUpload.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiPendingUpload;
        break;
    case ApiHelpName === ApiName.BinderDetails.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiBinderdetails;
        break;
    case ApiHelpName === ApiName.GetBinderInfo.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetBinderinfo;
        break;
    case ApiHelpName === ApiName.OCR.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiOCR;
        break;
    case ApiHelpName === ApiName.PushEngagementStatus.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiPushEngagementStatus;
        break;
    case ApiHelpName === ApiName.PushDocumentType.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiPushDocumentType;
        break;
    case ApiHelpName === ApiName.DocumentsUploaded.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiDocumentsUploaded;
        break;
    case ApiHelpName === ApiName.DRL.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiDRL;
        break;
    case ApiHelpName === ApiName.NewFileAvailable.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiNewFileAvailable;
        break;
    case ApiHelpName === ApiName.AcceptedFiles.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiAcceptedFiles;
        break;
    case ApiHelpName === ApiName.DRLOutputNotification.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiDRLOutputNotification;
        break;
    case ApiHelpName === ApiName.MIReport.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiMIReport;
        break;
    case ApiHelpName === ApiName.GetDRLOutput.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetDRLOutput;
        break;
    case ApiHelpName === ApiName.UpdateProjectID.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiUpdateProjectID;
        break;
    case ApiHelpName === ApiName.GetStateandLocation.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiStateandLocation;
        break;
    case ApiHelpName === ApiName.DownloadBinder.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiDownloadBinderPBFX;
        break;
    case ApiHelpName === ApiName.GetBinderStatuswithStates.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetBinderStatuswithStates;
        break;
    case ApiHelpName === ApiName.BinderAuditLog.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetBinderAuditLog;
        break;
    case ApiHelpName === ApiName.DRLCategories.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiDRLCategories;
        break;
    case ApiHelpName === ApiName.UpdateOwnerMember.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiUpdateOwnerMember;
        break;
    case ApiHelpName === ApiName.AccountUsageHistory.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiAccountUsageHistory;
        break;
    case ApiHelpName === ApiName.PrintBinder.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiPrintBinder;
        break; 
    case ApiHelpName === ApiName.CreateClient.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiCreateClient;
        break;
    case ApiHelpName === ApiName.GetClientDetails.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetClientDetails;
        break; 
    case ApiHelpName === ApiName.CreateDrl.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiCreateDrl;
        break;
    case ApiHelpName === ApiName.SendDrl.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiSendDrl;
        break;   
    case ApiHelpName === ApiName.ClientSubscribe.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiClientSubscribe;
        break;  
    case ApiHelpName === ApiName.ClientUnsubscribe.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiClientUnsubscribe;
        break;       
    case ApiHelpName === ApiName.GetDRLPDFDetails.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetDRLPDFDetails;
        break;
    case ApiHelpName === ApiName.TaxcaddyDownloadDocument.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiTaxcaddyDownloadDocument;
        break;
    case ApiHelpName === ApiName.GetDRLStatus.toLowerCase():
        XMLPath = ApiDcosxmlpath.ApiGetDRLStatus;
        break;
   case ApiHelpName === ApiName.TaxcaddyDisconnectDevices.toLowerCase():
            XMLPath = ApiDcosxmlpath.ApiTaxcaddyDisconnectDevices;
            break;
    default:
        XMLPath = ApiDcosxmlpath.ApiGetToken;
        break;
    }
    return XMLPath;
}

GetXmlpath.propTypes = {
    ApiHelpName: PropTypes.any,
};

export default GetXmlpath;
